/**
 * created by lei lei
 *绑定服务
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox} from "antd"
import CmModal from "../../../../components/CmModal/CmModal";
import BaseComponent from"../../../../base/BaseComponent"

export default class BindServiceModal extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            checkedList:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {
            visible
        } = this.props;
        let list=this.sysConfigGetValueByKey('service.switch.data','[]')||'[]';
        list=JSON.parse(list);
        return (
            <CmModal
                title="绑定服务"
                visible={visible}
                handleCancel={()=>{this.handleCancel()}}
                handleOk={()=>{this.handleOk()}}
                width={400}
                destroyOnClose={true}
            >
                <div style={{
                    height: "360px"
                }}>
                   {
                        list&&list.length?list.map((item,index)=>{
                            item.checked=this.state.checkedList.indexOf(item.code)>-1?true:false;
                            return(
                                <div key={index} style={{overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'}}><Checkbox checked={item.checked?true:false} onChange={()=>{this.onchange(item)}}/>&nbsp;&nbsp;<span style={{cursor:'pointer'}} title={item.code+'———'+item.title}>{item.code+'———'+item.title}</span></div>
                            )
                        }):'暂无数据'
                    }

                </div>
                {/*滚动条缝隙样式*/}
                <style>
                    {`.cm-scrollbars > div:nth-child(3){
                             margin-bottom: -8px;
                         `}
                </style>
            </CmModal>
        )
    }
    onchange(item){
        if(item.checked){
            this.state.checkedList.splice( this.state.checkedList.indexOf(item.code),1)
        }else{
            this.state.checkedList.push(item.code)
        }
        this.setState({})
    }
    handleCancel(){
        this.state.checkedList=[];
        this.setState({},()=>{
            this.props.handleCancel()
        });

    }
    setCheckedList(list=[]){
       this.state.checkedList=list;
       this.setState({})
    }

    handleOk(){
        let list=JSON.parse(JSON.stringify(this.state.checkedList));
        this.props.handleOk(list)
    }


}